<template>
  <div class="apps-container">
    <h5>Отслеживайте заказ в приложении</h5>
    <MobileApps />
  </div>
</template>

<script>
import MobileApps from '@components/MobileApps.vue'

export default {
  name: 'downloadApps',
  components: {
    MobileApps,
  },
}
</script>

<style lang="scss" scoped>
.apps-container {
  width: fit-content;
  margin-top: 20px;
  margin-right: auto;
  margin-left: auto;

  h5 {
    margin-bottom: 1rem;

    font-size: inherit;
    text-align: center;
  }

  :deep(.apps) {
    display: flex;
    justify-content: space-around;

    a {
      img {
        width: 100%;
        max-width: 128px;
        height: 40px;
      }
    }
    @media (max-width: 480px) {
      flex-direction: column;
      align-items: center;
    }
    @media (min-width: 480px) {
      a:not(:last-child) {
        margin-right: 6px;
      }
    }
  }
}
</style>
